import Vue from "vue";

const rawState = Vue.observable({});

const state = new Proxy(rawState, {
  get(target, prop) {
    if (!(prop in target)) {
      Vue.set(target, prop, false);
    }
    return target[prop];
  },
});

export default {
  install() {
    Vue.prototype.$modal = {
      state,
      open(name) {
        Vue.set(state, name, true);
      },
      close(name) {
        Vue.set(state, name, false);
      },
    };
  },
};
